import { render, staticRenderFns } from "./OrderViewActionMessage.vue?vue&type=template&id=2515b742&scoped=true&"
import script from "./OrderViewActionMessage.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionMessage.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActionMessage.vue?vue&type=style&index=0&id=2515b742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515b742",
  null
  
)

export default component.exports